import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from '@/app/providers';
import { AppRouter } from '@/app/router';
import '@/styles/globals.css';

async function bootstrap() {
  // Start MSW before React renders so the first network call is intercepted.
  // WHY: gated on env so we never ship the mock SW to production by accident.
  if (import.meta.env.VITE_USE_MOCK_API === 'true') {
    const { worker } = await import('@/mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: { url: '/mockServiceWorker.js' },
    });
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Root element #root not found in index.html');

  createRoot(container).render(
    <StrictMode>
      <Providers>
        <AppRouter />
      </Providers>
    </StrictMode>,
  );
}

void bootstrap();
